<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample"><span class="epub-i">Title Page</span></span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample"><span class="epub-i">Copyright Notice</span></span></p>
<p class="toc-bot"><a href="#/xhtml/intro#intro"><span class="epub-i">Introduction</span></a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Alcohol</a></p>
<p class="toc"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">Battle of the Sexes</span></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Bestiary</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Doctors</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Ethnic</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Golf</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Miscellaneous</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Old Folks</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Rednecks</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Women</span></p>
<p class="toc"><span href="#/xhtml/copyright" title="Link target outside of Sample"><span class="epub-i">Copyright</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3967b008